import { bool, node, string } from 'prop-types';
import './index.scss';


const CheckboxButtonGroup = (props) => {

    return (
        <div className="checkbox-button-group">
            {props.label && (
                <label className="form-label">{props.label}</label>
            )}
            {!props.label && props.alignWithInputs && (
                <label className="form-label checkbox-button-group-spacer" aria-hidden="true">&nbsp;</label>
            )}
            <div className="checkbox-button-row">
                {props.children}
            </div>
        </div>
    );
};

CheckboxButtonGroup.propTypes = {
    children: node.isRequired,
    label: string,
    alignWithInputs: bool
};

CheckboxButtonGroup.defaultProps = {
    label: '',
    alignWithInputs: false
};

export default CheckboxButtonGroup;
